// agriflow/companys/static/js/companys.js
import companysCreate from './modules/companysCreate.js'
import companysUpdate from './modules/companysUpdate.js'

document.addEventListener('DOMContentLoaded', function () {
    const companyscreate = new companysCreate();
    const companysupdate = new companysUpdate();
});